import { closeCurrentModal } from 'weblite-web-modal-viewer'
import { PopupMenuItem, PopupMenuList } from '$common/popup-menu'
import { RemoveCircleIcon } from '$common/icons/remove-circle'
import { unBlockUser } from '$logic/user-policy'
import { removeFromOpenedUserList } from '$logic/opened-user-list'
// Localization
import { t } from '$i18n'

interface Props {
  userId: string
  isOpen: boolean
}

export function RemoveBlockedUsersMenu({ userId, isOpen }: Props) {
  return (
    <PopupMenuList open={isOpen}>
      <PopupMenuItem
        text={t('menu.blockedUsers.unblocking')}
        onClick={async () => {
          analite('BLOCK_USER', {
            active: false,
            source: 'BLOCKED_USERS_PAGE',
          })
          await unBlockUser(userId)
          removeFromOpenedUserList(userId, 'blockedUsers')
          await closeCurrentModal()
        }}
      >
        <RemoveCircleIcon />
      </PopupMenuItem>
    </PopupMenuList>
  )
}
